<template>
    <div class="vehicle-data">
        <div>
            <p v-if="vehicle.owner.isOrganizationRepresentative">{{ $t('pages.vehicle.rented_out_by_a_company') }}</p>
            <ul class="overview-list">
                <template v-for="field in vehicleCharacteristics">
                    <OverviewListItem :key="field" :vehicle="vehicle" :field="field" />
                </template>

                <OverviewListItem v-if="!hasWinterTyres" :vehicle="vehicle" field="winterTyreType" />

                <li
                    v-for="(field, index) in checkboxVehicleCharacteristics"
                    :key="index"
                    class="vehicle-data__check-item"
                >
                    <svg-icon name="check" />
                    <div>
                        <strong>{{ $t(`vehicle_fields.${field}`) }}</strong>
                        <p v-if="field === 'winterTyreType'" class="vehicle-data__check-item__desc">
                            {{ $t(`pages.vehicle.vehicle_overview.${vehicle.winterTyreType}`) }}
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OverviewListItem from '~/components/vehicle/OverviewListItem.vue';
import { hiddenFieldsByVehicleType } from '~/config/vehicleFields';

export default {
    components: {
        OverviewListItem,
    },
    props: {
        vehicle: {
            type: Object,
            default: () => {},
        },
        displayAll: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fields: [
                'brand',
                'model',
                'modelYear',
                'transmission',
                'fueltype',
                'width',
                'length',
                'height',
                'curbWeight',
                'maximumAuthorizedMass',
            ],
            checkmarkFields: ['euro6Compliant', 'winterized', 'winterTyreType', 'childSafetySeat', 'allWheelDrive'],
        };
    },
    computed: {
        ...mapGetters(['isLargeScreen']),
        hasWinterTyres() {
            return this.vehicle.winterTyreType && this.vehicle.winterTyreType !== 'none';
        },
        vehicleCharacteristics() {
            return this.fields.filter(field => {
                return (
                    this.vehicle[field] !== undefined &&
                    this.vehicle[field] !== null &&
                    !hiddenFieldsByVehicleType[this.vehicle.subType].includes(field)
                );
            });
        },
        checkboxVehicleCharacteristics() {
            return this.checkmarkFields.filter(field => {
                if (field === 'winterTyreType') {
                    return this.hasWinterTyres;
                }

                return this.vehicle[field];
            });
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.vehicle-data {
    .overview-list {
        @include lg {
            columns: 2;
            column-gap: 20px;

            &--loading {
                columns: 1;
            }
        }

        @include xl {
            columns: 3;
        }

        .overview-list-item {
            flex-direction: row;

            &__label {
                color: $primary;
                font-weight: normal;

                &:after {
                    content: ':';
                }
            }

            &__value {
                line-height: 24px;
                font-weight: 600;
            }
        }

        a {
            text-decoration: none;
            font-weight: 600;
            line-height: 24px;
            color: $primary-text-color;
            width: fit-content;

            &:hover,
            &:active {
                text-decoration: underline;
            }
        }
    }

    &__check-item {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .svg-icon {
            width: 24px;
            height: 24px;
            min-width: 24px;
            color: $blue-dark;
            margin-right: 4px;
        }

        &__desc {
            @include font-size(14px);
            margin: 0;
        }
    }
}
</style>
